// Ordenamiento/límite compartido para rankings por año (Chart y Tabla de
// Familias/Clientes). Detalle completo en README.
export const MAX_FILAS_RANKING = 300;

// Ordena ascendente por `anioClave` y recorta según `orden`/`cantidad`.
// Siempre regresa `seleccionado` ascendente (ver README para el porqué).
export const ordenarYLimitarPorAnio = (datos = [], { anioClave, orden = "desc", cantidad = "todos" } = {}) => {
    const valorDe = (item) => item.valores[anioClave] || 0;
    const ascendente = [...datos].sort((a, b) => valorDe(a) - valorDe(b));
    const cantidadNum =
        cantidad === "todos" ? Math.min(ascendente.length, MAX_FILAS_RANKING) : Number(cantidad) || 0;
    const limitadoPorTope = cantidad === "todos" && ascendente.length > MAX_FILAS_RANKING;
    const seleccionado =
        orden === "asc"
            ? ascendente.slice(0, cantidadNum)
            : ascendente.slice(Math.max(ascendente.length - cantidadNum, 0));
    return { ascendente, seleccionado, limitadoPorTope };
};
